import instantIcon from "../../../assets/images/beneficios/instant.png";
import phoneIcon from "../../../assets/images/beneficios/telefono.svg";
import qrIcon from "../../../assets/images/beneficios/qr.svg";
import digitalIcon from "../../../assets/images/beneficios/cuenta-digital.svg";
import validationIcon from "../../../assets/images/beneficios/validacion.svg";
import cashIcon from "../../../assets/images/beneficios/cash.svg";
import referidosIcon from "../../../assets/images/beneficios/referidos.svg";
import recargasIcon from "../../../assets/images/beneficios/recargas.svg";
import historialIcon from "../../../assets/images/beneficios/historial.svg";
import personalizarIcon from "../../../assets/images/beneficios/personalizar.svg";

export const beneficios = {
    encabezado: {
        titulo: "Mira todo lo que Toke tiene pa ti",
        subtitulo: "Dale clic a cada función y entérate de lo que hay"
    },

    beneficios: [
        {
            id: 1,
            titulo: "Paga y cobra al instante",
            descripcion: "Manda y recibe dinero en segundos, 24/7 y sin comisiones. De celular a celular, sin cuenta ni números largos.",
            icono: instantIcon
        },
        {
            id: 2,
            titulo: "Paga con número de celular",
            descripcion: "Solo necesitas el número de celular.",
            icono: phoneIcon
        },
        {
            id: 3,
            titulo: "Tu código QR personal",
            descripcion: "Utiliza tu propio código QR para que te paguen de una vez.",
            icono: qrIcon
        },
        {
            id: 4,
            titulo: "Obtén tu cuenta 100% digital",
            descripcion: "Sin filas y sin papeleos, solo necesitas tu celular.",
            icono: digitalIcon
        },
        {
            id: 5,
            titulo: "Valida tus pagos ahí mismo",
            descripcion: "Podrás verificar en tiempo real el estado de tus pagos.",
            icono: validationIcon
        },
        {
            id: 6,
            titulo: "Retira efectivo con Código Cash",
            descripcion: "Usa un Código Cash y retira sin tener que andar con tarjeta a mano.",
            icono: cashIcon
        },
        {
            id: 7,
            titulo: "Recibe dinero al invitar amigos",
            descripcion: "Obtén recompensas al referir a tus amigos a que se descarguen la app.",
            icono: referidosIcon
        },
        {
            id: 8,
            titulo: "Haz tus recargas telefónicas",
            descripcion: "Recarga tu celular o Paso Rápido desde un solo sitio.",
            icono: recargasIcon
        },
        {
            id: 9,
            titulo: "Cobra con códigos QR",
            descripcion: "Cobra fácil en tu negocio con QR, sin líos ni efectivo.",
            icono: qrIcon
        },
        {
            id: 10,
            titulo: "Chequea tu historial",
            descripcion: "Mira la Actividad de la Cuenta en tiempo real, pa’ que no pierdas ni un peso.",
            icono: historialIcon
        },
        {
            id: 11,
            titulo: "Personaliza tus pagos",
            descripcion: "Ponle tu flow a cada pago. Agrégale emojis y comentarios como tú quieras.",
            icono: personalizarIcon
        }
    ]
};
